import { render, staticRenderFns } from "./CTab.vue?vue&type=template&id=3a1ee533&scoped=true&"
import script from "./CTab.vue?vue&type=script&lang=js&"
export * from "./CTab.vue?vue&type=script&lang=js&"
import style0 from "./CTab.vue?vue&type=style&index=0&id=3a1ee533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ee533",
  null
  
)

export default component.exports